import {Container,Col,Row} from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import reactresim from "../assets/images/reactresim.png";
import css from "../assets/images/css.png";
import html from "../assets/images/html.png";
import javascript from "../assets/images/javascript.png";
import c from "../assets/images/csharp.png";
import python from "../assets/images/python.png";
import swift from "../assets/images/swift.png";
import postgresql from "../assets/images/postgresql.png";
import vsc from "../assets/images/vsc.png";
import jupyter from "../assets/images/jupyter.png";
import npm from "../assets/images/npm.png";
import numpy from "../assets/images/numpy.png";
import pandas from "../assets/images/pandas.png";
import colorSharp from "../assets/images/color-sharp.png";



export const Skills = () => {
    const responsive = {
        superLargeDesktop:{
            breakpoint:{max:4000,min:3000},
            items:5
        },
        desktop:{
            breakpoint:{max:3000,min:1024},
            items:3
        },
        tablet:{
            breakpoint:{max:1024,min:464},
            items:2
        },
        mobile:{
            breakpoint:{max:464,min:0},
            items:1
        }
    };
    return(
        <section className="skill" id="skills">
            <Container>
                <Row>
                    <Col>
                        <div className="skill-bx">
                            <h1>
                                Skills
                            </h1>
                            <p></p>
                            <Carousel responsive={responsive} infinite={true} className="skill-slider">
                                <div className="item">
                                    <img src={reactresim} alt="Image" />
                                    <h5>React</h5>
                                </div>
                                <div className="item">
                                    <img src={css} alt="Image" />
                                    <h5>Css</h5>
                                </div>
                                <div className="item">
                                    <img src={html} alt="Image" />
                                    <h5>HTML5</h5>
                                </div>
                                <div className="item">
                                    <img src={javascript} alt="Image" />
                                    <h5>JavaScript</h5>
                                </div>
                                <div className="item">
                                    <img src={c} alt="Image" />
                                    <h5>C#</h5>
                                </div>
                                <div className="item">
                                    <img src={python} alt="Image" />
                                    <h5>Python</h5>
                                </div>
                                <div className="item">
                                    <img src={swift} alt="Image" />
                                    <h5>Swift</h5>
                                </div>
                                <div className="item">
                                    <img src={postgresql} alt="Image" />
                                    <h5>PostgreSql</h5>
                                </div>
                                <div className="item">
                                    <img src={npm} alt="Image" />
                                    <h5>Npm</h5>
                                </div>
                                <div className="item">
                                    <img src={jupyter} alt="Image" />
                                    <h5>Jupyter</h5>
                                </div>
                                <div className="item">
                                    <img src={numpy} alt="Image" />
                                    <h5>Numpy</h5>
                                </div>
                                <div className="item">
                                    <img src={pandas} alt="Image" />
                                    <h5>Pandas</h5>
                                </div>
                                <div className="item">
                                    <img src={vsc} alt="Image" />
                                    <h5>VSCode</h5>
                                </div>
                            </Carousel>
                        </div>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-left" src={colorSharp} />
            
        </section>
    )
}